<template>
    <div>
        <FileScrubber></FileScrubber>
    </div>
</template>


<script>
import FileScrubber  from "./FileScrubber.vue";

export default {
    name: 'BenCommTools',
    components: {FileScrubber},
}
</script>
